import styled, { css } from 'styled-components'
import Portal from '@app.components/Portal'

interface ExamAlertDesktopProps {
  message: string
  type: 'alert' | 'confirm'
  buttonLabel?: string
  isMobile?: boolean
  onClickCloseModal?: () => void
  onClickConfirm: () => void
}

const ExamAlert = ({
  message,
  type = 'alert',
  buttonLabel = '확인',
  isMobile = false,
  onClickCloseModal,
  onClickConfirm,
}: ExamAlertDesktopProps) => {
  const handleClickCloseModal = () => {
    if (onClickCloseModal) {
      onClickCloseModal()
    }
  }

  const handleClickConfirm = () => {
    onClickConfirm()
  }

  return (
    <Portal id="career-alert-modal">
      <StyledWrapper>
        <article className="alert-modal-content">
          <p data-device-type={isMobile ? 'mobile' : 'desktop'}>{message}</p>
          <div className="button-wrap">
            {type === 'confirm' && (
              <button
                type="button"
                className="button-cancel-route"
                onClick={handleClickCloseModal}
              >
                취소
              </button>
            )}
            <button
              type="button"
              className="button-change-route"
              onClick={handleClickConfirm}
            >
              {buttonLabel}
            </button>
          </div>
        </article>
      </StyledWrapper>
    </Portal>
  )
}

export default ExamAlert

const StyledWrapper = styled.aside`
  ${({ theme }) => css`
    width: 100vw;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    z-index: 10000;
    overflow-y: auto;

    & > .alert-modal-content {
      min-width: 340px;
      padding: 45px 20px 40px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: ${theme.background.bg_8};
      border-radius: 20px;

      & > p {
        font-size: 20px;
        font-weight: normal;
        line-height: 1.5;
        letter-spacing: -0.8px;
        text-align: center;
        color: ${theme.color.text_1};
        white-space: pre-wrap;
        overflow-wrap: break-word;
        margin-bottom: 30px;

        &[data-device-type='mobile'] {
          font-size: 16px;
        }
      }

      & > .button-wrap {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin: 0 auto;

        & > button {
          width: 93px;
          height: 50px;
          padding: 13px 30px;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: -0.64px;
          text-align: center;
          color: #ffffff;
          border: 0;
          border-radius: 8px;
          cursor: pointer;

          &.button-cancel-route {
            background-color: #bbbbbb;
          }

          &.button-change-route {
            width: 102px;
            background-color: ${theme.color.primary_2};
          }
        }
      }
    }
  `}
`
